module.exports = __webpack_public_path__ + "static/media/26UNRWA16.7e2d8373.jpg";